import { SapNewOrder, SapSalesOrder } from '@allurion/domain';
import { FIVE_MINUTES_IN_MS } from '@allurion/utils';
import { useMemo } from 'react';
import useSWR from 'swr';

import { buildUrl, InsightsApi } from 'src/api/Api';

const PATHNAME = (clinicId: string) => `/clinics/${clinicId}/orders`;

export function useClinicOrders(clinicId?: string, suspense = true) {
  const url =
    clinicId &&
    buildUrl(PATHNAME(clinicId.toString()), {
      pageSize: 100,
    });
  const { data, error, isValidating, mutate } = useSWR(
    url,
    (_url: string) => InsightsApi.get<{ orders: SapSalesOrder[] }>(_url),
    {
      revalidateOnFocus: false,
      suspense,
      dedupingInterval: FIVE_MINUTES_IN_MS,
    }
  );

  async function createOrder(order: SapNewOrder) {
    await InsightsApi.post(PATHNAME(clinicId!), order);
    await mutate();
  }

  const sortedOrders = useMemo(
    () =>
      data?.orders.sort((a, b) => {
        const aId = a.id.toLowerCase();
        const bId = b.id.toLowerCase();

        if (aId < bId) {
          return 1;
        }
        if (aId > bId) {
          return -1;
        }

        return 0;
      }),
    [data?.orders]
  );

  return {
    isLoading: isValidating,
    orders: sortedOrders ?? [],
    createOrder,
    error,
  };
}
